<p-toast position="top-right"></p-toast>
<p-toast key="swChat" position="top-right">
  <ng-template let-message pTemplate="message">
    <div class="sw-chat-toast" role="button" tabindex="0" title="Open this chat" (click)="openChatToast(message)"
      (keydown.enter)="openChatToast(message)">
      <svg class="sw-chat-toast__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
      </svg>
      <div class="sw-chat-toast__text">
        <div class="p-toast-summary">{{ message.summary }}</div>
        <div class="p-toast-detail">{{ message.detail }}</div>
      </div>
    </div>
  </ng-template>
</p-toast>

@if (sidebar || header) {
<div class="sw-app d-flex flex-column overflow-hidden vh-100">
  @if (header) {
  <app-header class="flex-shrink-0"></app-header>
  }

  <div class="sw-layout d-flex flex-grow-1 overflow-hidden w-100 position-relative">
    @if (sidebar) {
    <app-sidebar [ngClass]="isMobileSideBarShow ? 'd-contents' : 'd-none d-lg-contents'"
      [mobileOpen]="isMobileSideBarShow" (collapsedEvent)="collapsedEvent($event)">
    </app-sidebar>
    }

    <main class="sw-main-content flex-grow-1 overflow-auto min-h-0 w-100">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>

<!-- Shared "Cameras" slide-over — hosted once, driven by SiteService state.
     Every entry point (site-list view-all + quick-disarm, users/sites,
     setting-modal, speaker) sets siteService.camera* then calls openCameraDrawer(). -->
<sw-drawer [(visible)]="siteService.cameraDrawerVisible" title="Cameras" width="min(42rem, 100vw)"
  (hide)="siteService.closeCameraDrawer()">
  <div drawer-body>
    @if (siteService.cameraDrawerVisible) {
    <app-camera-model [embedded]="true"></app-camera-model>
    }
  </div>
</sw-drawer>

<!-- Shared "Site Camera Create Zone" slide-over — opened from the Cameras panel's
     "Create Zone" button. flushBody: the editor draws its own edge-to-edge
     body + pinned Discard/Save footer. -->
<sw-drawer [(visible)]="siteService.zoneDrawerVisible" title="Site Camera Create Zone" width="min(48rem, 92vw)"
  [scrollBody]="false" [flushBody]="true" (hide)="siteService.closeZoneDrawer()">
  <!-- Fill the fixed drawer body so the editor's height:100% resolves and its
       Discard/Save footer pins to the very bottom edge. -->
  <div drawer-body style="display:flex; flex-direction:column; flex:1 1 auto; min-height:0;">
    @if (siteService.zoneDrawerVisible) {
    <app-zone-create-model [embedded]="true"></app-zone-create-model>
    }
  </div>
</sw-drawer>

<!-- Shared "Add / Update Site" slide-over — opened from the Sites list (add row /
     edit row). Narrow single-column for edit, wide multi-column form for add. -->
<sw-drawer [(visible)]="siteService.siteDrawerVisible"
  [title]="siteService.siteDrawerAdding ? 'Add Site' : 'Update Site'" width="min(90rem, 96vw)" [scrollBody]="false"
  [flushBody]="true" (hide)="siteService.closeSiteDrawer()">
  <div drawer-body style="display:flex; flex-direction:column; flex:1 1 auto; min-height:0;">
    @if (siteService.siteDrawerVisible) {
    <app-client-modal [embedded]="true"></app-client-modal>
    }
  </div>
</sw-drawer>

<app-user-manual></app-user-manual>
} @else {
<router-outlet></router-outlet>
}